import styled from "@emotion/styled";
import { CardHeader } from "@mui/material";
import Card from "@mui/material/Card";

export const PropositionCard = styled(Card)`
  display: grid;
  gap: 16px;
  margin: 16px;
  width: 100%;
  padding: 20px 36px;
  border-radius: 32px;
`;

export const CardTitle = styled(CardHeader)`
  font-weight: bold;
  font-size: 1.25rem;
  margin-bottom: 8px;
`;
